import React, { ReactNode, useEffect } from "react";
import "./SplitScreen.scss";

type Direction = "horizontal" | "vertical";

interface SplitScreenProps {
  direction?: Direction;
  firstContent: ReactNode;
  secondContent?: ReactNode;
  fullHeight?: boolean;
  firstScroll?: boolean;
  secondScroll?: boolean;
  height?: string;
  firstClassName?: string;
  secondClassName?: string;
}

const SplitScreen: React.FC<SplitScreenProps> = ({
  direction = "horizontal",
  firstContent,
  secondContent,
  fullHeight = true,
  firstScroll = false,
  secondScroll = false,
  height,
  firstClassName = "",
  secondClassName = ""
}) => {
  const hasSecond = !!secondContent;
  const layoutClass = direction === "horizontal" ? "split-horizontal" : "split-vertical";
  const computedHeight = fullHeight ? (direction === "vertical" ? "100%" : undefined) : height;
  const lockPageScroll = hasSecond && firstScroll && secondScroll;

  useEffect(() => {
    if (lockPageScroll) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [lockPageScroll]);

  const wrapperClasses = ["split-screen", layoutClass, lockPageScroll ? "no-scroll" : "allow-scroll"]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={wrapperClasses} style={{ height: computedHeight }}>
      <div className={`split-pane first-pane ${firstScroll ? "scroll-enabled" : "scroll-disabled"} ${firstClassName}`}>
        {firstContent}
      </div>
      {hasSecond && (
        <div
          className={`split-pane second-pane ${secondScroll ? "scroll-enabled" : "scroll-disabled"} ${secondClassName}`}
        >
          {secondContent}
        </div>
      )}
    </div>
  );
};

export default SplitScreen;
